module.exports = __webpack_public_path__ + "img/Laugh.e840d135.png";